import { render, staticRenderFns } from "./TxRow.vue?vue&type=template&id=1a13e26f"
import script from "./TxRow.vue?vue&type=script&lang=js"
export * from "./TxRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports